import { createSlice } from '@reduxjs/toolkit';

// Utility function to clean non-serializable values
const cleanSubscription = (subscription) => {
  const { id, Account, AccountId, Building, BuildingId, JobType, DisplayName, DataInput, UserInput, State, AlgorithmInput } = subscription;

  return {
    id: id || '',
    Account: Account || '',
    AccountId: AccountId || '',
    Building: Building || {},
    BuildingId: BuildingId || '',
    JobType: JobType || '',
    DisplayName: DisplayName || '',
    DataInput: DataInput || {},
    UserInput: UserInput || {},
    State: State ? {
      ...State
    } : {},
    AlgorithmInput: AlgorithmInput || {}
  };
};

export const selectedSubscriptionSlice = createSlice({
    name: 'selectedSubscription',
    initialState: {},
    reducers: {
        setSelectedSubscription: (state, action) => {
            return cleanSubscription(action.payload);
        }
    }
});

export const { setSelectedSubscription } = selectedSubscriptionSlice.actions;

export const getSelectedSubscription = (state) => state?.selectedSubscription;

export default selectedSubscriptionSlice.reducer;